import { render } from "./uploadImageField.vue?vue&type=template&id=2f5b5f6d&scoped=true"
import script from "./uploadImageField.vue?vue&type=script&lang=js"
export * from "./uploadImageField.vue?vue&type=script&lang=js"

import "./uploadImageField.vue?vue&type=style&index=0&id=2f5b5f6d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5b5f6d"]])

export default __exports__